// テーマ全体に関わるJS処理を記述

/* Footer */
// Scroll to Top
function backToTop() {
  const btn = document.querySelector("#scrollTopBtn");
  btn.addEventListener('click', () => {
    window.scroll({ 
      top: 0, 
      behavior: "smooth"
    });
  });
}

// Footer Acordion
function mobileAcordion() {
  const acordionArray = document.querySelectorAll('[data-action="toggle-collapsible"]'),
        mediaQueryList = window.matchMedia("screen and (min-width: 1000px)");

  function acordionToggle(btn, content) {
    let contentHeight = 0;

    content.querySelectorAll(".c-footer__linkist-item").forEach((item) => {
      contentHeight = contentHeight + item.clientHeight + 15;
    })

    if (btn.getAttribute("aria-expanded") === "true") {
      content.style.height = 0;
      btn.setAttribute("aria-expanded", "false");
    } else {
      content.style.height = contentHeight + "px";
      btn.setAttribute("aria-expanded", "true");
    }
  }

  acordionArray.forEach((accordion) => {
    let accordionContent = document.getElementById(accordion.getAttribute("aria-controls"));

    accordion.addEventListener("click", () => {
      acordionToggle(accordion, accordionContent);
    })

    if(mediaQueryList.matches) {
      accordion.setAttribute("disabled", "disabled");
      accordion.setAttribute("aria-expanded", "false");
      accordionContent.style.height = "";
    } else {
      accordion.removeAttribute("disabled");
    }

    mediaQueryList.addEventListener("change", (event) => {
      if (event.matches) {
        accordion.setAttribute("disabled", "disabled");
        accordion.setAttribute("aria-expanded", "false");
        accordionContent.style.height = "";
      } else {
        accordion.removeAttribute("disabled");
      }
    })
  })
  
}

window.addEventListener('DOMContentLoaded',function(){
  backToTop();
  mobileAcordion();
});